import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,MDBCarouselItem, MDBAlert, MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBDataTable } from 'mdbreact';
import { Form, Input, Button, Checkbox, message,Divider  } from 'antd';
import { Steps } from 'antd';


import Axios from 'axios'

import Swal from 'sweetalert2'
import { api } from '../../api';
import Modaladdwork from './Modaladdwork';
import Modaladdlist from './Modaladdlist';
import Modaladdworkedit from './Modaladdworkedit';
import NumberFormat from 'react-number-format';
import Modaladdworkpay from './Modaladdworkpay';
import { Bar } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";
import LoadingOverlay from 'react-loading-overlay';
const { Step } = Steps;



export default class Pageworkreportpay extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,

                code:'',
                bd:'',
                OLDID:'',
                BDATE:'',
                PNAME:'',
                NAME:'',
                FACULTY:'',

                authscore:[],
                authcount:'',
                studentcheck:[],
                work:[],
                workpay:[],
                workpaycount:'',
                stap1:'',
                stap2:'',
                stap3:'',
                stap4:'',
                stap5:'',

                datesearch1:'',
                datesearch2:'',
                loading:false,
            };
           
            this.handleSubmitstu = this.handleSubmitstu.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getworkreport = this.getworkreport.bind(this);
            this.gotocheck = this.gotocheck.bind(this);
            this.senttographic = this.senttographic.bind(this);
            this.getworkcount = this.getworkcount.bind(this);
            this.handleSubmitsearch = this.handleSubmitsearch.bind(this);
            this.getworkcountsearch = this.getworkcountsearch.bind(this);
          
          
            
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
         }

        //  getscore (){
        //     api.get('selectauthscore.php?id_authorities='+localStorage.getItem('id_authorities'))
        //     .then(res => {
        //     //  console.log(res);
        //     //  this.setState({ bankname: res.data, loading: false })
        //       this.setState({ authscore: res.data})
        //     }) 
        // }

        gotocheck(event) {

         //   console.log(event.target.value);
            const id = event.target.value;
            window.location.href = 'https://lookmaenamping.com/sorlalum/Checkstudentlist/'+id;

        }

        getworkreport (){
          this.setState({ loading:true})
            api.get('selectworkpay.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
             this.setState({ workpay: res.data,  loading: false})
              
            }) 
        }

        getworkcount (){
            api.get('selectworkpaycount.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
             this.setState({ workpaycount: res.data[0].total})
              
            }) 
        }

        getworkcountsearch (){
          this.setState({ loading:true})
          setTimeout(() => {
    
            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
            datafrm.append("datesearch1", this.state.datesearch1);
            datafrm.append("datesearch2", this.state.datesearch2);
          
      
            api.post("selectworkpaycountsearch.php",datafrm,{
                                  headers: {
                                      'content-type': 'multipart/form-data'
                                  }
                              })
      
                              .then(res => {
                                //  console.warn(res);
                                 // console.log("response: ", res)
                                  if (res.data.length !== 0) {
                                    this.setState({ workpaycount: res.data[0].total,  loading: false})
                            
                                  }else{
                                  // window.location.href = '/'
                                  }
      
                              })
      
                  }, 1000);
      }

      
    

       

        senttographic(event) {
          //  console.log(event.target.value);
            const date = new Date().toISOString().slice(0, 10)
            const gg = event.target.value

            Swal.fire({
              title: 'ยืนยัน',
              text: "ส่งไปยังฝ่ายกราฟฟิก",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ตกลง',
             cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                 if (result.isConfirmed) {

                    setTimeout(() => {
        
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("id", gg);
                        datafrm.append("datesent", date);
                        api.post("updatesenttographic.php",datafrm,{
                         headers: {
                                   'content-type': 'multipart/form-data'
                                  }
                                  })
                                          .then(res => {
                                             // console.warn(res);
                                             // console.log("response: ", res)
                                              if (res.status=== 200) {
            
                                            Swal.fire({
                                              title: 'ส่งไปยังฝ่ายกราฟฟิกสำเร็จ',
                                              icon: 'success',
                                            // showCancelButton: true,
                                              confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.getwork();
                                             // window.location.href = '/'
                                            })
                  
                                              }else{
                                              // window.location.href = '/'
                                              }
                  
                                          })
                  
                              }, 1000);
                  
                 // console.log('ok')
                  } else if (result.isDenied) {
                   // Swal.fire('Changes are not saved', '', 'info')
                  }
            })
         
           }
     


          handleSubmitstu() {
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("OLDID", this.state.OLDID);
              datafrm.append("BDATE", this.state.BDATE);
              datafrm.append("PNAME", this.state.PNAME);
              datafrm.append("NAME", this.state.NAME);
              datafrm.append("FACULTY", this.state.FACULTY);
        
              api.post("insertstudent.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.status=== 200) {
  
                                  Swal.fire({
                                    title: 'ยืนยันลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                    this.toggle();  
                                    window.location.href = '/kprurun2021'
                                  })
        
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        //window.location.href = '/adminfaculty'
        //this.props.updateat();
        //this.getExpert()
        
          }


          handleSubmitsearch(e) {
            e.preventDefault();
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("datesearch1", this.state.datesearch1);
              datafrm.append("datesearch2", this.state.datesearch2);
            
        
              api.post("selectworkpaysearch.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.data.length !== 0) {
                                      this.setState({ workpay: res.data})
                                  // Swal.fire({
                                  //   title: 'ยืนยันลงทะเบียนสำเร็จ',
                                  //   icon: 'success',
                                  //  showCancelButton: true,
                                  //   confirmButtonText: 'ตกลง',
                                  //  cancelButtonText: 'No, keep it'
                                  // }).then((result) => {
                                  //   this.toggle();  
                                  //   window.location.href = '/kprurun2021'
                                  // })
        
                                  this.getworkcountsearch()
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        //window.location.href = '/adminfaculty'
        //this.props.updateat();
          
        
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
                window.location.href = '/sorlalum'
            } else {
  
            }
              this.getworkreport();
              this.getworkcount();
          }
        

 

    render() {
     // console.log(this.state.code)
//      var d = new Date(date),
//      month = '' + (d.getMonth() + 1),
//      day = '' + d.getDate(),
//      year = d.getFullYear();
//const date = new Date().toISOString().slice(0, 10)
//  if (month.length < 2) 
//      month = '0' + month;
//  if (day.length < 2) 
//      day = '0' + day;
let dss;
//            const date = year + '-' + month + '-' + day;
     //console.log(date)
     const data = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'รหัส',
            field: 'OLDID',
            sort: 'OLDID',
            width: 270
          },
          {
            label: 'ชื่องาน',
            field: 'NAME',
            sort: 'NAME',
            width: 200
          },
           {
            label: 'วันที่เพิ่ม',
            field: 'DATES',
            sort: 'DATES',
            width: 200
          },
          {
            label: 'จำนวนเงิน',
            field: 'FACULTY',
            sort: 'FACULTY',
            width: 100
          },
          {
            label: 'ตรวจสอบ',
            field: 'check',
            sort: 'check',
            width: 100
          }

        ],

        rows: [...this.state.workpay.map((data, i) => (
          {
             list: <>{i+1}</>,
             OLDID: <>{data.code_workorder}</>,
             NAME: <>{data.name_workorder}</>,
             DATES: <>{data.dateadd_workorder}</>,
             FACULTY: <><NumberFormat value={data.price_workorder}  displayType={'text'} thousandSeparator={true}  /></>,
             check: <>
             {data.statusfinish_workorder === '5' ?<>
              <Modaladdworkpay id_workorder={data.id_workorder} getwork={this.getwork} />
              </>:<>
              {data.statusfinish_workorder === '6' ?<>
             <p className="teal-text"><MDBIcon icon="dollar-sign" /> ชำระเงินแล้ว </p>
              </>:<>
              //  <Modaladdlist code={data.code_workorder} name_workorder={data.name_workorder} 	id_workorder={data.id_workorder}   /> 
              //   <Modaladdworkedit id_workorder={data.id_workorder} />
              //   {data.statussentgf_workorder == 1 ?<></>:<> <MDBBtn color="dark-green" size="sm" value={data.id_workorder} onClick={this.senttographic} ><MDBIcon icon="share-square" /> ส่งไปยังกราฟฟิก</MDBBtn></>}
              </>}
              
              </>}
         
             </>,

            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const persons = <MDBDataTable
   // searching ={true}
    searchLabel="ค้นหา รายการ"
    striped
    bordered
    small 
    entries={20}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
/>




      const  statechat = {
        dataBar: {
          labels: ["รับงาน", "กราฟฟิก", "ผลิต", "เสร็จสิ้น", "ชำระเงิน"],
          datasets: [
            {
              label: "% of Votes",
              data: [this.state.stap1, this.state.stap2, this.state.stap3, this.state.stap4, this.state.stap5],
              backgroundColor: [
                "rgba(255, 134,159,0.4)",
                "rgba(98,  182, 239,0.4)",
                "rgba(255, 218, 128,0.4)",
                "rgba(113, 205, 205,0.4)",
                "rgba(170, 128, 252,0.4)"
              ],
              borderWidth: 2,
              borderColor: [
                "rgba(255, 134, 159, 1)",
                "rgba(98,  182, 239, 1)",
                "rgba(255, 218, 128, 1)",
                "rgba(113, 205, 205, 1)",
                "rgba(170, 128, 252, 1)"
              ]
            }
          ]
        },
        barChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                barPercentage: 1,
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                },
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }
      }
    
    

        return (

          <LoadingOverlay
          active={this.state.loading}
          spinner
          text='Loading your data...'
          >
       
                <MDBContainer fluid >
  <h2 className="font-weight-bold  text-center">  รายงานสรุปการเงิน</h2>
<p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ดูแลระบบ</p>
      <MDBRow >
          <div >
              {/* <Modaladdwork/>  */}
          </div> 
       
        <MDBCol md="12" className="d-flex justify-content-center">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                    <MDBCardBody>
                    <MDBCardTitle className="text-center">  รายการชำระเงิน</MDBCardTitle>
                    <br/>

<div className='d-flex justify-content-center'>
                    <form onSubmit={this.handleSubmitsearch} >
                    <MDBRow>
                       <MDBCol md="5">

                                <div >
                                    <label className="font-weight-bold"><MDBIcon icon="calendar-alt" /> วันที่</label>
                                    <input className="form-control" type="date" onChange={this.onTextChange} name="datesearch1"
                                        value={this.state.appointment_workorder} placeholder="" required />
                                </div>
                       </MDBCol>
                      <MDBCol md="2">
                      <p className='text-center'>ถึง</p> 
                      </MDBCol>
                     <MDBCol md="5">
                                   <div >
                                    <label className="font-weight-bold"><MDBIcon icon="calendar-alt" /> วันที่</label>
                                    <input className="form-control" type="date" onChange={this.onTextChange} name="datesearch2"
                                        value={this.state.appointment_workorder} placeholder="" required />
                                </div>
                     </MDBCol>
                    </MDBRow>
                             
                           <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="primary" className="text-center"> <MDBIcon far icon="save" /> ค้นหา</MDBBtn>
                            </div>  
                            {/* <p className='text-center'>ถึง</p> */}
                           
                    </form>
                    <br/>
</div>

                    <h2 className="font-weight-bold  text-left">  รวมเงิน : <NumberFormat value= {this.state.workpaycount}  displayType={'text'} thousandSeparator={true}  /> บาท</h2>
                    <div className='text-center'>
                        {/* <MDBBtn color="purple">ตรวจหลักฐาน</MDBBtn> */}
                    </div>
                     {persons}
                     {/* <Bar data={statechat.dataBar}  /> */}
                    </MDBCardBody>

                   
         </MDBCard>
        </MDBCol>
       

      </MDBRow>
      {/* SELECT tb_score.oldid_score, tb_score.num_score, tb_score.file_score, tb_score.date_score, tb_score.status_score, tb_student.PNAME, tb_student.NAME
FROM tb_score
INNER JOIN tb_student ON tb_score.oldid_score=tb_student.OLDID */}

<br/>

    


                   
                    </MDBContainer>
                   
                    </LoadingOverlay>  
        )
    }
}
